import React from 'react';

import {Button, Stack, Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';
import {StyledCard, StyledCardContent, StyledImage} from './styles';
import {ProductCardProps} from './types';

const {button} = translations['pt-br'].privateFlow.perks.lifeplace.products;

export const ProductCard = ({
	installment,
	installmentValue,
	listPrice,
	price,
	name,
	imageUrl,
	link,
}: ProductCardProps) => {
	const handleClick = () => {
		window.open(link, '_blank');
	};

	return (
		<StyledCard elevation={0} variant="outlined">
			<StyledCardContent>
				<StyledImage src={imageUrl} alt={name} />

				<Typography variant="body1" color="text.primary" textAlign="center">
					{name}
				</Typography>

				<Stack mt="auto" gap={2} width="100%">
					<Stack alignItems="center">
						{listPrice ? (
							<Typography
								variant="body2"
								color="text.primary"
								sx={{textDecoration: 'line-through'}}>
								{listPrice}
							</Typography>
						) : null}

						<Typography fontSize={24} fontWeight={700} color="primary.main">
							{price}
						</Typography>
						{installmentValue ? (
							<Typography variant="body2" color="text.primary">
								{installment}x de {installmentValue}
							</Typography>
						) : null}
					</Stack>

					<Button variant="contained" color="primary" fullWidth onClick={handleClick}>
						{button}
					</Button>
				</Stack>
			</StyledCardContent>
		</StyledCard>
	);
};
